import React, { useState, useEffect, useCallback } from 'react';
import { PRESET_CONCENTRATIONS } from '../constants/syringeTypes';
import './ReconstitutionCalculator.css';

function ReconstitutionCalculator() {
  const [peptideMg, setPeptideMg] = useState('');
  const [desiredConcentration, setDesiredConcentration] = useState('');
  const [bacWaterNeeded, setBacWaterNeeded] = useState(null);

  const calculateBacWater = useCallback(() => {
    const peptideValue = parseFloat(peptideMg);
    const concentrationValue = parseFloat(desiredConcentration);

    if (peptideMg && desiredConcentration && concentrationValue > 0) {
      const water = (peptideValue / concentrationValue).toFixed(2);
      setBacWaterNeeded(water);
    } else {
      setBacWaterNeeded(null);
    }
  }, [peptideMg, desiredConcentration]);

  useEffect(() => {
    calculateBacWater();
  }, [calculateBacWater]);

  return (
    <div className="calculator-panel">
      <h2 className="panel-title">Reconstitution Calculator</h2>
      <p className="panel-description">
        Calculate how much bacteriostatic water to add to your peptide vial
      </p>

      <div className="input-group">
        <label className="input-label">
          Peptide Amount (mg)
          <span className="input-hint">Total peptide in vial</span>
        </label>
        <input
          type="number"
          className="input-field"
          value={peptideMg}
          onChange={(e) => setPeptideMg(e.target.value)}
          placeholder="e.g., 10"
          min="0"
          step="0.1"
        />
      </div>

      <div className="input-group">
        <label className="input-label">
          Desired Concentration (mg/mL)
          <span className="input-hint">Target concentration after reconstitution</span>
        </label>
        <input
          type="number"
          className="input-field"
          value={desiredConcentration}
          onChange={(e) => setDesiredConcentration(e.target.value)}
          placeholder="e.g., 2"
          min="0"
          step="0.1"
        />

        <div className="preset-buttons">
          {PRESET_CONCENTRATIONS.map((preset) => (
            <button
              key={preset.value}
              className="preset-button"
              onClick={() => setDesiredConcentration(preset.value.toString())}
            >
              {preset.label}
            </button>
          ))}
        </div>
      </div>

      {bacWaterNeeded && (
        <div className="result-box">
          <div className="result-label">Bacteriostatic Water Needed</div>
          <div className="result-value">
            <span className="result-number">{bacWaterNeeded}</span>
            <span className="result-unit">mL</span>
          </div>
          <div className="result-info">
            Add {bacWaterNeeded} mL of bacteriostatic water to {peptideMg} mg of peptide to achieve{' '}
            {desiredConcentration} mg/mL concentration
          </div>
        </div>
      )}

      <div className="info-box">
        <h3>Quick Tips:</h3>
        <ul>
          <li>Use sterile bacteriostatic water only</li>
          <li>Add water slowly down the side of the vial</li>
          <li>Gently swirl to mix - do not shake vigorously</li>
          <li>Store reconstituted peptide in refrigerator</li>
        </ul>
      </div>
    </div>
  );
}

export default ReconstitutionCalculator;
